import { SearchCustomerVm, CustomerVm, CustomersInformationVm } from './viewModel';
import { AttendanceInformation, Customer, CustomerSelected, CustomersInformation } from '../../models/api-client';
import { AttendanceVm } from '../Customer/Cases/viewModel';
import customerMapper from '@/views/Customer/Cases/mappers';
import { FormatterHelper } from '../../common/utils/FormatterHelper';

const createSearchCustomerVm = (): SearchCustomerVm => ({
  osaGuid: '',
  id: 0,
  anspName: '',
  adrePlz: '',
  adreOrt: '',
  adreStrasse: '',
  anspZusatztext: '',
  adreLand: '',
  anspTelPrivat: '',
  anspTelGesch: '',
  anspTelAlternativ: '',
  anspMobil: '',
});

const createCustomerVm = (): CustomerVm => ({
  osaGuid: '',
  id: 0,
  firstName: '',
  anspName: '',
  adrePlz: '',
  adreOrt: '',
  anspAdressInfo: [],
  adreStrasse: '',
  locked: false,
  updateBerechtigt: false,
  prepaidSupportHours: 0,
  spentSupportHours: 0,
  openedCases: [],
  closedCases: [],
});

const createCustomerInformationVm = (): CustomersInformationVm => ({
  customer: createCustomerVm(),
  coCustomer: createCustomerVm()
});

const mapCustomerDtoListToSearchCustomerVmList = (customerDtoList: Customer[]): SearchCustomerVm[] => customerDtoList.map(mapCustomerDtoToSearchCustomerVm);


const mapCustomerDtoToSearchCustomerVm = (customerDto: Customer): SearchCustomerVm => ({
  osaGuid: customerDto.osaGuid,
  id: customerDto.debtorNumber,
  anspName: customerDto.anspName,
  adrePlz: customerDto.adrePlz,
  adreOrt: customerDto.adreOrt,
  adreStrasse: customerDto.adreStrasse,
  anspZusatztext: customerDto.anspZusatztext,
  adreLand: customerDto.adreLand,
  anspTelPrivat: customerDto.anspTelPrivat,
  anspTelGesch: customerDto.anspTelGesch,
  anspTelAlternativ: customerDto.anspTelAlternativ,
  anspMobil: customerDto.anspMobil,
  debtorNumber: customerDto.debtorNumber,
});

const mapCustomerDtoToSelectedCustomerVm = (customerDto: CustomersInformation): CustomersInformationVm => ({
  customer: mapCustomerDtoCustomerVm(customerDto.customer),
  coCustomer: customerDto.coCustomer != null ? mapCustomerDtoCustomerVm(customerDto.coCustomer) : null
});

const mapCustomerDtoCustomerVm = (customerDto: CustomerSelected): CustomerVm => ({
  osaGuid: customerDto.osaGuid,
  id: customerDto.debtorNumber,
  firstName: customerDto.anspVorname,
  anspName: customerDto.anspName,
  adrePlz: customerDto.adrePlz,
  adreOrt: customerDto.adreOrt,
  anspAdressInfo: customerDto.anspAdressInfo.split('\r\n'),
  adreStrasse: customerDto.adreStrasse,
  locked: customerDto.locked,
  updateBerechtigt: customerDto.updateBerechtigt,
  prepaidSupportHours: customerDto.prepaidSupportHours,
  spentSupportHours: customerDto.spentSupportHours,
  openedCases: customerMapper.mapCaseListDtoToCaseListOpenVm(customerDto.openedCases),
  closedCases: customerMapper.mapCaseListDtoToCaseListCloseVm(customerDto.closedCases),
  kundengruppe: customerDto.kundengruppe,
  siteKundennummer: customerDto.siteKundennummer,
  produktlinien: customerDto.produktlinien,
});

const mapAttendanceDtoToAttendanceVm = (attendanceDto: AttendanceInformation): AttendanceVm => ({
  staffSignature: attendanceDto.staffSignature,
  caTcDescription: attendanceDto.caTcDescription,
  caTcStart: FormatterHelper.extractHourToDate(attendanceDto.caTcStart),
  hour: FormatterHelper.extractDateToDate(attendanceDto.caTcStart),
  caTcEnd: FormatterHelper.extractDateToDate(attendanceDto.caTcEnd),
  caTcHours: attendanceDto.caTcHours,
  caTcHoursFree: attendanceDto.caTcHoursFree,
});

const mapAttendanceListDtoToAttendanceListVm = (attendances: AttendanceInformation[]): AttendanceVm[] => attendances.map(mapAttendanceDtoToAttendanceVm);


export default {
  createSearchCustomerVm,
  createCustomerInformationVm,
  mapCustomerDtoToSearchCustomerVm,
  mapCustomerDtoListToSearchCustomerVmList,
  mapCustomerDtoToSelectedCustomerVm,
  mapAttendanceDtoToAttendanceVm,
  mapAttendanceListDtoToAttendanceListVm,
};
